import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useDispatch, useSelector } from 'react-redux';
import { Drawer, useMediaQuery, useTheme } from '@mui/material';
// import { closeSidebar } from 'src/actions/chatActions';
import Toolbar from './Toolbar';
import ThreadList from './ThreadList';

const PREFIX = 'Sidebar';

const classes = {
  drawerDesktopRoot: `${PREFIX}-drawerDesktopRoot`,
  drawerDesktopPaper: `${PREFIX}-drawerDesktopPaper`,
  drawerMobilePaper: `${PREFIX}-drawerMobilePaper`,
  drawerMobileBackdrop: `${PREFIX}-drawerMobileBackdrop`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(() => ({
  [`& .${classes.drawerDesktopRoot}`]: {
    width: 280,
    flexShrink: 0,
  },

  [`& .${classes.drawerDesktopPaper}`]: {
    position: 'relative',
  },

  [`& .${classes.drawerMobilePaper}`]: {
    position: 'relative',
    width: 280,
  },

  [`& .${classes.drawerMobileBackdrop}`]: {
    position: 'absolute',
  },
}));

function Sidebar({ containerRef, threads }) {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const location = useLocation();
  // const { sidebarOpen } = useSelector((state) => state.chat);

  // const handleCloseSidebar = () => {
  //   dispatch(closeSidebar());
  // };

  // useEffect(() => {
  //   if (sidebarOpen) {
  //     dispatch(closeSidebar());
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [location.pathname]);

  const content = (
    <div>
      {/* <Toolbar /> */}
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <ThreadList threads={threads} />
      </PerfectScrollbar>
    </div>
  );

  return (
    <Root>
      {isLargeScreen && (
        <Drawer
          variant='permanent'
          classes={{
            root: classes.drawerDesktopRoot,
            paper: classes.drawerDesktopPaper,
          }}
        >
          {content}
        </Drawer>
      )}
      {!isLargeScreen && (
        <Drawer
          variant='temporary'
          // open={sidebarOpen}
          /* onClose={handleCloseSidebar} */
          classes={{
            paper: classes.drawerMobilePaper,
          }}
          style={{ position: 'absolute', zIndex: 1200 }}
          BackdropProps={{ root: classes.drawerMobileBackdrop }}
          ModalProps={{ container: () => containerRef.current }}
        >
          {content}
        </Drawer>
      )}
    </Root>
  );
}

Sidebar.propTypes = {
  containerRef: PropTypes.any,
};

export default Sidebar;
